import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Longtrip, On the road",
  "description": "",
  "published": "2013-08-11T00:00:00.000Z",
  "redirect_from": ["/blog/longtrip-on-the-road/swizec/6307"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/FONpdCiJTHqBWavUrmsF",
        "alt": "Spanish desert",
        "title": "Spanish desert"
      }}></img></p>
    <p>{`This is the most boring road.`}</p>
    <p>{`A vast windfarm stands still around us. The scenery is sometimes flat, sometimes full of rock formations displaying layers of geographical history. Dotted with shrubbery and covered in tough light-brown grasses the Spanish desert extends into the horizon in all directions.`}</p>
    <p>{`Occasional torro silhouettes made of steel are the only clue this isn't any other desert in the world. Waking up after dozing off feels like no time has passed at all. Everything remains exactly the same.`}</p>
    <p>{`The sign we just passed says we're at 1100 meters above sea level. It warns us of possible ice on the road. Where the ice could come from I don't know, we haven't seen a single cloud in three days. But we'll be careful, I guess.`}</p>
    <p>{`At least there is traffic on this road.`}</p>
    <p>{`The traffic makes this vast sameness feel less lonely - passing the occasional slow truck or giving way to a fast `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Speedy_Gonzales",
        "title": "Speedy Gonzales"
      }}>{`Speedy Gonzales`}</a>{` in a modern car also gives you something to do when you're driving. The back roads we took from Andorra to `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=41.65,-0.883333333333&spn=0.1,0.1&q=41.65,-0.883333333333%20(Zaragoza)&t=h",
        "title": "Zaragoza"
      }}>{`Zaragoza`}</a>{` yesterday were completely deserted.`}</p>
    <p>{`Had anything happened it would've been game over. The vultures would pick our bones dry by morning.`}</p>
    <p>{`Tonight we're camping near Merida, a small town near the border with `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=38.7666666667,-9.15&spn=10.0,10.0&q=38.7666666667,-9.15%20(Portugal)&t=h",
        "title": "Portugal"
      }}>{`Portugal`}</a>{`; two days ago we stayed at a hotel in `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Millau",
        "title": "Millau"
      }}>{`Millau`}</a>{`, France. Yesterday we woke up after a freezing night in a camp in the middle of `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=42.5,1.51666666667&spn=10.0,10.0&q=42.5,1.51666666667%20(Andorra)&t=h",
        "title": "Andorra"
      }}>{`Andorran`}</a>{` mountains. Tomorrow we're going to be in Portugal.`}</p>
    <p>{`Roadtrips are surreal.`}</p>
    <p>{`Everything happens so fast we don't even have time to write postcards from all the interesting places. I wrote last week's blogpost in the middle of `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=45.8336111111,6.865&spn=0.01,0.01&q=45.8336111111,6.865%20(Alps)&t=h",
        "title": "Alps"
      }}>{`Italian Alps`}</a>{` ...`}</p>
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/astjhDOXShuzib7Jp9FJ",
        "alt": "Tea in Millau",
        "title": "Tea in Millau"
      }}></img></p>
    <p>{`Millau was a sleepy town where the historic centre streets are deserted until 3pm when they become bustling with activity of everyone going to and fro. I'm not sure if those were tourists or locals enjoying a slow summer afternoon. There were a lot of families with strollers and small humans racing around getting in the way of our longboards.`}</p>
    <p>{`A few hours later we were practically locals. Everywhere we went we'd meed somebody who served us tea or food that day. That afternoon we literally walked down every street in the historic center.`}</p>
    <p>{`Climbing the `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=42.6322222222,0.657777777778&spn=0.1,0.1&q=42.6322222222,0.657777777778%20(Pyrenees)&t=h",
        "title": "Pyrenees"
      }}>{`Pyrenees`}</a>{` into Andorra was the polar opposite of the relentless Spanish desert towards Portugal.`}</p>
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/dnGQfnyzRSmrGyyVk6SV",
        "alt": "Mountains before Andorra",
        "title": "Mountains before Andorra"
      }}></img></p>
    <p>{`The countryside lush with greenery. Deep forests as far as the eye can see; infinite pastures at the peak of our climb - 2100 meters according to Kaylee. Windows down to enjoy the fresh mountain air, we could always hear the trickle of some nearby stream. Probably not always the same stream.`}</p>
    <p>{`And oh my was the road fun to drive! Vroom down a short straight, breaks screeching into corners and fast shifting between third, fourth and fifth gear to keep the average speed up.`}</p>
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/5gr3dufcT5eDsJCBkNxz",
        "alt": "Desert between Andorra and Zaragoza",
        "title": "Desert between Andorra and Zaragoza"
      }}></img></p>
    <p>{`The only time we've gone out of fifth today was stopping for gas and sandwiches. Otherwise it's just a constant pressure on the gas and away we go at 120km/h not slowing down for anything or anyone. Like a lorry.`}</p>
    <p>{`At Zaragoza yesterday we finally found some young people.`}</p>
    <p>{`Camps and hotels are full of old people and their underage kids, so we tend to have only each other for company. Random patrons of the hostel we stayed at in Zaragoza were a welcome break.`}</p>
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/dPoVgPa0QFAzuSIdQmVD",
        "alt": "A square in Zaragoza",
        "title": "A square in Zaragoza"
      }}></img></p>
    <p>{`Out in the historic centre a Venezuelan girl who lives in Barcelona scalded us for staying only a single night. She said Zaragoza is much too pretty to go over in a single evening. I tend to agree.`}</p>
    <p>{`But we left the beautiful Zaragoza before 10am today to head west into the desert. We spent the day bored out of our skulls and now we're enjoying the cool evening at a campsite bar just outside Merida. The wifi craps out every two minutes, the barbecue smells divine and orujo burns our throats.`}</p>
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/9RgP2nP5Th2MYSsw4URL",
        "alt": "Sunset in Zaragoza",
        "title": "Sunset in Zaragoza"
      }}></img></p>
    <p>{`The Michael Jackson fits perfectly.`}</p>
    <p>{`Tomorrow we go check out the roman theatre in Merida and stare into the ocean from the westermost point of Europe. It's going to be fun.`}</p>
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/PGh8obOJSgqOZLbkrUIy",
        "alt": "Some more desert :)",
        "title": "Some more desert :)"
      }}></img></p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=de53230f-10d1-4441-8656-b59dc0e12d71",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      